import React from "react";
import { motion } from "framer-motion";
import { PauseCircleIcon, ClockIcon, CompassIcon, SplitIcon, BoxIcon } from "lucide-react";
import { painPoints } from "../data/content";
const icons: Record<string, BoxIcon> = {
  pause: PauseCircleIcon,
  clock: ClockIcon,
  compass: CompassIcon,
  split: SplitIcon
};
export function PainPoints() {
  return <section id="te-identificas" className="w-full border-t border-ink/5 bg-ivory py-20 sm:py-28" aria-labelledby="te-identificas-title" data-id="element-65" data-mp="2bvo89ee7p7ls">
      <div className="mx-auto max-w-6xl px-6 lg:px-8" data-id="element-66" data-mp="21z32gqudbsgw">
        <div className="max-w-xl" data-id="element-67" data-mp="220o2gvzgc3m5">
          <p className="font-sans text-xs uppercase tracking-[0.28em] text-gold-deep" data-id="element-68" data-mp="1nztolxtmxag3">
            ¿Te identificas?
          </p>
          <h2 id="te-identificas-title" className="mt-5 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-69" data-mp="1szpuk2lw7bya">
            Quizá el miedo no grita. Solo te va apagando.
          </h2>
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2" data-id="element-70" data-mp="3nbmruc70nc19">
          {painPoints.map((point, i) => {
          const Icon = icons[point.icon];
          return <motion.li key={point.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08,
            ease: 'easeOut'
          }} className="flex gap-5" data-id="element-71" data-mp="1u1u2f49st2m5" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold-soft/30 text-gold-deep" data-id="element-72" data-mp="1b2zjrk77ri0p">
                  <Icon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-73" data-mp="1p3k26f97vbto" />
                </span>
                <div data-id="element-74" data-mp="1k2cyose3wyst">
                  <h3 className="font-serif text-xl text-ink" data-id="element-75" data-mp="1k232gn2gxveo">{point.title}</h3>
                  <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-76" data-mp="30gcqth6pnk5i">
                    {point.text}
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}